document.addEventListener('DOMContentLoaded', () => {
  var stickyNav = document.querySelector('[data-sticky-nav]');
  var selectSizeBtn = document.querySelector('[data-select-size-btn]');
  var addToCartButton = document.querySelector('.product-form__buttons');
  var stickyAddToCartButton = document.querySelector('.sticky-add-to-cart');

  /**
   * Checks if the element is visible in the viewport.
   * @param {HTMLElement} element - The element to check for visibility.
   * @returns {boolean} - True if the element is visible, false otherwise.
   */
  var isElementInViewport = (element) => {
    var rect = element.getBoundingClientRect();
    var isDesktop = window.innerWidth > 749; 
    if (isDesktop) {
      return (
        rect.bottom > 0 && // Element is partially visible vertically
        rect.right > 0 && // Element is partially visible horizontally
        rect.left < (window.innerWidth || document.documentElement.clientWidth)
      );
    }
    else{
      return (
        rect.top >= 0 && // Element is fully visible at the top
        rect.left >= 0 && // Element is fully visible at the left
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && // Element is fully visible at the bottom
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) // Element is fully visible at the right
      );
    }
  };

  /**
   * Toggles the visibility of the sticky navigation section
   * based on the visibility of the "Add to Cart" button.
   */
  var toggleStickyNav = () => {
    var addToCartButton = document.querySelector('.product-form__buy-button:not(.hidden) .product-form__buttons');
    if (!addToCartButton) {
      addToCartButton = document.querySelector('.product-notify-with-similar.product-form__buttons');
    }
    var stickyNav = document.querySelector('[data-sticky-nav]');
    if (!isElementInViewport(addToCartButton)) {
      // Show sticky navigation if the "Add to Cart" button is not visible
      stickyNav.classList.add('show');
      document.body.classList.add('sticky-bar-enabled');
    } else {
      // Hide sticky navigation if the "Add to Cart" button is visible
      stickyNav.classList.remove('show');
      document.body.classList.remove('sticky-bar-enabled');
    }
  };

  /**
   * Select Size Behaviour (goes to the top of the page)
   */
  selectSizeBtn?.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });

  /**
   * Add to Cart Behaviour
   */
  var handleStickyAddToCartClick = async () => {
    var stickyAddToCartButton = document.querySelector('.sticky-add-to-cart');
    var spinner = stickyAddToCartButton.querySelector('.loading__spinner');

    stickyAddToCartButton.classList.add('loading');
    stickyAddToCartButton.disabled = true;
    spinner.classList.remove('hidden');
    let originalAddToCartButton =
      addToCartButton.querySelector('.product-main-atc');
    originalAddToCartButton?.click();

    await new Promise((resolve) => setTimeout(resolve, 1000));

    stickyAddToCartButton.classList.remove('loading');
    stickyAddToCartButton.disabled = false;
    spinner.classList.add('hidden');
  };

  // Initialize the sticky "Add to Cart" button click event
  stickyAddToCartButton?.addEventListener('click', handleStickyAddToCartClick);

  // Initial check in case the page loads with the button out of view
  toggleStickyNav();

  // Add a scroll event listener to monitor changes in the viewport
  window.addEventListener('scroll', toggleStickyNav);

  // Optionally, monitor window resizing as well if layout changes on resize
  window.addEventListener('resize', toggleStickyNav);
});
